import styled from "styled-components";

import { DaycareSearchResultListStyle } from "@components/daycare/daycareSearchResultList/daycareSearchResultListStyle";

export const ChildrenSearchResultListStyle = styled(DaycareSearchResultListStyle)`
    padding-left: 15px;
`;
